import React, {useContext, useState, useRef} from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Box, Card, CardContent, Typography, Stack, TextField, Button, Divider, Dialog, Alert } from "@mui/material"

import { AppContext } from '/@/app/AppContext';
import { useApi} from '/@/app/Api';
import { useAuth, getAccessToken, setAccessToken } from "/@/Auth";
import { PasswordField, VerifyView } from '/@/Auth';
import { messageStackState } from "/@/app/states/messageStackState";

function calcAge(birthdayStr)
{
	const birth = new Date(birthdayStr);
	const today = new Date();

	let age = today.getFullYear() - birth.getFullYear();

	const m = today.getMonth() - birth.getMonth();

	if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
		age--;
	}

	return age;
}

function VerifyDialog({ open, verifyKey, onClose, onSuccess})
{
const { t } = useTranslation();

const [message,setMessage] = useState(null)

return (
<Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
<Stack spacing={2} sx={{p:3}}>

{message&&( <Alert severity={message.type||"error"} sx={{py:0.5}}> {t(message.text)} </Alert>)}

<VerifyView verifyKey={verifyKey} setMessage={setMessage} onSuccess={(action) => onSuccess(action)} onClose={()=>onClose()} />
</Stack>

</Dialog>
);
}

export const ProfileView = () =>
{
const { t } = useTranslation();
const api=useApi();
const { bootstrapData } = useContext(AppContext);
const [ email, setEmail ]= useState('');
const [ emailPassword, setEmailPassword ]= useState('');
const [ newPassword, setNewPassword ]= useState('');
const [ newPassword2, setNewPassword2 ]= useState('');

const [ emailVerifyOpen, setEmailVerifyOpen] = useState(false);
const [ verifyKey, setVerifyKey] = useState(null);


const [ emailSearch, setEmailSearch ]= useState('');
const [ emailSearchOptions, setEmailSearchOptions ]= useState([]);

const user = { age: calcAge(bootstrapData.user.birthday), sex: t({'male':'Мужской','female':'Женский'}[bootstrapData.user.gender]), email: bootstrapData.user.email, }

const confirm_email_change= () =>
{
	api.request( `profile/confirm_email_change`,{'email':email, 'password':emailPassword}, {method:'POST',api_url:'v2', 
		silentStatuses:{422:(e)=>{
			let m='Ошибочные параметры';
			if (e.data.detail[0].loc?.[1]=='email') m='Неправильный адрес';
			if (e.data.detail[0].loc?.[1]=='password') m='Неправильный пароль';
    			messageStackState.addMessage({text: m, tags: 'error'});
		}}}
	)
	.then(async re => {
		if (re.error)
		{
    			messageStackState.addMessage({text: re.error, tags: 'error'});
			return;
		};
		if (!re.verify)
		{
    			messageStackState.addMessage({text:t( re.detail || "Не удалось подтвердить адрес"), tags: 'error'});
			return;
		};
		setVerifyKey(re.verify);
		setEmailVerifyOpen(true);
	})
	.catch(re=>{
		console.log('confirm_email_change error',re);
	});

};

const email_verified= (action) =>
{
	setEmailVerifyOpen(false);
	if (action=='email_change')
	{
		messageStackState.addMessage({text: t('Адрес успешно изменён. Страница перезагружается.'), tags: 'success'});
		setTimeout(()=>location.reload(),2000);
	};
	if (action=='password_change')
	{
		messageStackState.addMessage({text: t('Пароль успешно изменён.'), tags: 'success'});
	};
};

const confirm_password_change= () =>
{
	api.request( `profile/confirm_password_change`,{'password':newPassword,'password2':newPassword2}, {method:'POST',api_url:'v2', 
		silentStatuses:{422:(e)=>{
			let m='Ошибочные параметры';
			if (e.data.detail[0].loc?.[1]=='password') m='Неправильный пароль';
			if (e.data.detail[0].loc?.[1]=='password2') m='Пароли не совпадают';
    			messageStackState.addMessage({text: m, tags: 'error'});
		}}}
	)
	.then(async re =>
	{
		if (re.error) { messageStackState.addMessage({text: re.error, tags: 'error'}); return; };
		if (!re.verify) { messageStackState.addMessage({text:t( re.detail || "Не удалось подтвердить адрес"), tags: 'error'}); return; };
		setVerifyKey(re.verify);
		setEmailVerifyOpen(true);
	})
	.catch(re=>{
		console.log('confirm_password_change error',re);
	});

};

const email_search_debounce=useRef(null);
const handle_email_search= (event) =>
{
	const value=event?.target.value ??'';
	setEmailSearch(value);
	if (email_search_debounce.current) clearTimeout(email_search_debounce.current);
	email_search_debounce.current = setTimeout(() => {
		api.request( `admin/email_lookup`,{'email_search':value,'limit':10}, {api_url:'v2', })
		.then((re)=>
		{
			setEmailSearchOptions(re);
		});
	}, 500);

}
const handle_switch_user= (revert=false) =>
{
	const endpoint=revert?'admin/revert_user':'admin/switch_user';
	const data=revert?{}:{'email':emailSearch};
	api.request( endpoint,data, {api_url:'v2', })
	.then((re)=>
	{
		if (re.error) { messageStackState.addMessage({text: re.error, tags: 'error'}); return; };
		if (!re.refresh) { messageStackState.addMessage({text: 'Не удалось переключить пользователя', tags: 'error'}); return; };

		setAccessToken(re.access)
		localStorage.setItem('jwt_refresh', re.refresh);

		messageStackState.addMessage({text: t('Пользователь переключен. Страница перезагружается.'), tags: 'success'});
		setTimeout(()=>location.reload(),2000);
	});

}


return (
<Box maxWidth={600} mx="auto">
<VerifyDialog verifyKey={verifyKey} open={emailVerifyOpen} onClose={()=>setEmailVerifyOpen(false)} onSuccess={(action)=>email_verified(action)}/>

<Stack spacing={3}>

<Card>
<CardContent>
<Stack spacing={2}>
<Typography variant="h6">Профиль </Typography>
<Stack direction="row" justifyContent="space-between">
<Box> <Typography>Возраст: {user.age}</Typography> <Typography>Пол: {user.sex}</Typography> </Box>
<Button component={Link} to="../finish-registration/" variant="contained" > Изменить </Button>
</Stack>
</Stack>
</CardContent>
</Card>


<Card>
<CardContent>
<Stack spacing={2}>
<Typography variant="h6">Электронный адрес </Typography>
<TextField label="Текущий адрес" value={user.email} disabled fullWidth />
<TextField label="Новый адрес" fullWidth value={email} onChange={e=>setEmail(e.target.value)} autoComplete="off"/>
<PasswordField label={t('Пароль')} type="password" fullWidth value={emailPassword} setPassword={setEmailPassword} autoComplete="off"/>
<Box textAlign="right"> <Button variant="contained" onClick={()=>confirm_email_change()}>Изменить </Button> </Box>
</Stack>
</CardContent>
</Card>


<Card>
<CardContent>
<Stack spacing={2}>
<Typography variant="h6">Пароль </Typography>
<PasswordField label={t('Новый пароль')} type="password" fullWidth value={newPassword} setPassword={setNewPassword}/>
<PasswordField label={t('Повторите пароль')} type="password" fullWidth value={newPassword2} setPassword={setNewPassword2}/>
<Box textAlign="right"> <Button variant="contained" onClick={()=>confirm_password_change()}>Изменить</Button> </Box>
</Stack>
</CardContent>
</Card>

{(bootstrapData.user.is_superuser || bootstrapData.user.debug_mode) && (
<Card>
<CardContent>
<Stack spacing={2}>


<Typography variant="h6">Админ </Typography>

{bootstrapData.user.debug_mode && ( <>
<TextField label="Переключенный аккаунт" value={user.email} disabled fullWidth />
<Box textAlign="right"> <Button variant="contained" onClick={()=>handle_switch_user(true)}>Отменить переключение</Button> </Box>
</>)}

{!bootstrapData.user.debug_mode && ( <>
<TextField type="text" value={emailSearch} onChange={(e)=>handle_email_search(e)} placeholder="Search email..." autoComplete='off' inputProps={{ list: "email-search-options", }} />

<datalist id="email-search-options">
{emailSearchOptions.map(o => ( <option key={o.email} value={o.email} />))}
</datalist>
<Box textAlign="right"> <Button variant="contained" onClick={()=>handle_switch_user()}>Переключить</Button> </Box>
</>)}
</Stack>
</CardContent>
</Card>
)}


</Stack>

</Box>

);

};


